The candidate profile that the process history item belongs to.
